import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SharedService {
  constructor() { }
  socialLinks = [
    {
      'title': 'facebook',
      'url': 'https://www.facebook.com/fayaport80/',
      'icon': 'facebook-f'
    },
    {
      'title': 'twitter',
      'url': 'https://twitter.com/FayaPort80',
      'icon': 'twitter'
    },
    {
      'title': 'instagram',
      'url': 'https://www.instagram.com/fayaport80/',
      'icon': 'instagram'
    },
    {
      'title': 'youtube',
      'url': 'https://www.youtube.com/fayausa',
      'icon': 'youtube'
    },
    {
      'title': 'meetup',
      'url': 'https://www.meetup.com/FAYA-PORT-80/',
      'icon': 'meetup'
    }
  ];
}
